import {Component, Inject} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from "../../../applied-filters-updater";
import {AbstractFilterComponent} from "../../abstract-filter.component";
import {AdvancedFilterOperatorEnum, AdvanceFilterParamType} from "../../advance-filter";

@Component({
    selector: 'app-checkbox-filter',
    templateUrl: './checkbox-filter.component.html',
    styleUrl: './checkbox-filter.component.scss'
})
export class CheckboxFilterComponent extends AbstractFilterComponent {

    constructor(formBuilder:FormBuilder,
                @Inject(IAppliedFiltersUpdaterToken) filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
        super(formBuilder, filterUpdater);
    }

    override setUpForm(): void {
        this.filterForm = this._formBuilder.group({
            value: ['', [Validators.required]],
            operator: [AdvancedFilterOperatorEnum.eq],
        });
    }
}
